import { render, staticRenderFns } from "./PaymentPendingPage.vue?vue&type=template&id=43a13c20&scoped=true"
import script from "./PaymentPendingPage.vue?vue&type=script&lang=js"
export * from "./PaymentPendingPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPendingPage.vue?vue&type=style&index=0&id=43a13c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a13c20",
  null
  
)

export default component.exports